import { useMutation } from '@apollo/client/react';
import { UPDATE_STATEMENT_DELIVERY_MUTATION } from '../../integrations/allkort/graphql/gql/CustomerMutations';
import {
    StatementMailingDeliveryType,
    UpdateStatementDeliveryInput,
    UpdateStatementDeliveryResponse,
} from '../../integrations/allkort/graphql/interface/CustomerMutation';

/**
 * useUpdateStatementDelivery
 *
 * Custom hook for updating the customer's statement (kontobesked) mailing delivery type.
 *
 * @example
 * ```tsx
 * const { updateStatementDelivery, loading, error, data } = useUpdateStatementDelivery();
 *
 * await updateStatementDelivery({
 *   customerId: 442603,
 *   deliveryType: StatementMailingDeliveryType.EMAIL_DISPATCH,
 * });
 * ```
 */
export const useUpdateStatementDelivery = () => {
	const [updateStatementDeliveryMutation, { loading, error, data }] = useMutation<
		UpdateStatementDeliveryResponse,
		UpdateStatementDeliveryInput
	>(UPDATE_STATEMENT_DELIVERY_MUTATION, { errorPolicy: 'all' });

	const updateStatementDelivery = async (input: UpdateStatementDeliveryInput) => {
		return updateStatementDeliveryMutation({
			variables: {
				customerId: input.customerId,
				deliveryType: input.deliveryType,
			},
		});
	};

	return { updateStatementDelivery, loading, error, data };
};

export { StatementMailingDeliveryType };
